// OUTObjectType_Headless.tsx
import * as React from "react"
import "./index.css"
import { objectTypes } from './swmmreact'

// type: A string representing the object type 'NODE', 'AREA', 'LINK', or 'SYS'
// onChange: The update function for the main control.
interface IObjectTypeHeadless {
  type: keyof typeof objectTypes,
  onChange: any
}

const OUTObjectType_Headless = ({ type, onChange }:IObjectTypeHeadless) => {
  // If the input changes, then change the parent model.
  React.useEffect(() => {
    onChange({name: 'type', value: type })
  }, [])

  return(<></>)
}
 
export {OUTObjectType_Headless}